import React, { useEffect } from 'react'
import Box from '@material-ui/core/Box'
import PlayerReportCashAccountingForm from '../../../components/admin/playerReport/cashAccounting/PlayerReportCashAccountingForm'
import PlayerReportCashAccountingTable from '../../../components/admin/playerReport/cashAccounting/PlayerReportCashAccountingTable'
import useGDK from '../../../providers/admin/gdk/useGDK'
import { Branch } from '@golden/gdk-admin'

const PlayerReportCashAccountingPage: React.FC = () => {
  const gdk = useGDK()
  useEffect(() => {
    gdk.trunk.trigger([Branch.PLATFORMS, Branch.PUBLISHERS])
  }, [gdk])
  return (
    <Box paddingY={5}>
      <Box paddingX={5}>
        <PlayerReportCashAccountingForm />
      </Box>
      <Box paddingTop={3}>
        <PlayerReportCashAccountingTable />
      </Box>
    </Box>
  )
}

export default React.memo(PlayerReportCashAccountingPage)
